import React from 'react';
import PropTypes from 'prop-types';
import formatNumberWithCommas from '../../utils/format-number-with-commas';

const Percent = (props) => {
  const { decimalRounding, emptyState } = props;
  let { value } = props;
  const numeric = value !== null && value !== undefined ? parseFloat(value) : null;
  if (decimalRounding !== undefined && numeric !== null && !isNaN(numeric)) {
    value = numeric.toFixed(decimalRounding);
  } else {
    value = numeric !== null && !isNaN(numeric) ? numeric : null;
  }

  return (
    <span>
      {value ? `${formatNumberWithCommas(value)}%` : emptyState}
    </span>
  );
};

Percent.propTypes = {
  value: PropTypes.number,
  decimalRounding: PropTypes.number,
  emptyState: PropTypes.string,
};

Percent.defaultProps = {
  decimalRounding: undefined,
  value: null,
  emptyState: '--',
};

export default Percent;
